export enum Unit{
    Percentage='%',
    LITRE='L',
    LITRE_TFU='L',
    RPM='RPM',
    KM='Km',
    KMH='Km/h',
    NONE=''
    
}

export const UNIT_Array: Unit[]= Object.values(Unit);